import React from 'react';

import './Loader.scss';

export interface LoaderProps {
  type?: 'spinner' | 'tile' | 'bounce';
  size?: 'small' | 'medium' | 'large' | 'xxl';
  color?: 'primary' | 'secondary';
}
export const Loader = ({
  type = 'tile',
  size = 'small',
  color = 'primary',
}: LoaderProps): JSX.Element => {
  const selectedColor =
    color === 'primary' ? 'u-color-primary' : 'u-color-porter-blue';
  const className = `loader is-${size} ${selectedColor}`;
  switch (type) {
    case 'spinner':
      return (
        <div className={className}>
          <div className="loader__spinner" />
        </div>
      );

    case 'bounce':
      return (
        <div className={className}>
          <div className="loader__bounce">
            <div className="loader__bounce__ball" />
            <div className="loader__bounce__ball" />
            <div className="loader__bounce__ball" />
          </div>
        </div>
      );

    default:
      return (
        <div className={className}>
          <div className="loader__tiles">
            <div className="loader__tiles__tile" />
            <div className="loader__tiles__tile" />
            <div className="loader__tiles__tile" />
            <div className="loader__tiles__tile" />
          </div>
        </div>
      );
  }
};
